import { Icon } from 'src/components'
import styled from 'styled-components'

export const PostModalUserName = styled.h3`
  font-size: 0.875rem;
`

PostModalUserName.displayName = 'PostModalUserName'

export const Divider = styled.div`
  height: 1rem;
  border-left: 0.063rem solid var(--gray-200);
`

Divider.displayName = 'Divider'

export const CustomIcon = styled(Icon)`
  width: 1.25rem;
  height: 1.25rem;
`

CustomIcon.displayName = 'PostModalHeaderCustomIcon'

export const CustomButton = styled.button`
  &:focus,
  :active {
    outline: 0;
  }
`

CustomButton.displayName = 'CustomButtonPostModalHeader'
